import {appAPI} from "../../../api";
import {
    IFleetDashboard,
    IFleetIncidentDetail,
} from "../../../models/IFleetDashboard";

const basePath = `/machinery-telemetry`;

export const fleetDashboardAPI = {
    /**
     * Сводный дашборд по всему автопарку за период.
     * GET /machinery-telemetry/fleet/dashboard?from=…&to=…
     * company_id берётся из JWT на бэке — здесь не передаём.
     */
    getDashboard: async (
        from: string,
        to: string,
        signal?: AbortSignal,
    ): Promise<IFleetDashboard> => {
        const res = await appAPI.get(`${basePath}/fleet/dashboard`, {
            params: {from, to},
            signal,
        });
        return res.data;
    },

    /**
     * Детали инцидентов одной машины за период (ленивая подгрузка в модалке).
     * GET /machinery-telemetry/fleet/incidents/:machineryId?from=…&to=…
     * Возвращает события DESC по occurred_at. Изоляция тенанта — на бэке (404).
     */
    getIncidents: async (
        machineryId: string,
        from: string,
        to: string,
    ): Promise<IFleetIncidentDetail[]> => {
        const res = await appAPI.get(
            `${basePath}/fleet/incidents/${machineryId}`,
            {params: {from, to}},
        );
        return res.data;
    },
};
